<template lang="pug">
van-popup.container(v-model="memeberShow", position="bottom", :style="{ height: '70%' }", @close="closeHandler")
  .btnRow
    van-button.cancelBtn(size="mini", @click="memeberShow = false") 取消
    span.title 选择成员
    van-button.submitBtn(size="mini", @click="onSubmit") 确定
  //- 选人菜单
  van-tabs.tabs(v-model="memberType", color="#4777E7", title-active-color="#4777E7", @change="radioClick")
    van-tab(v-for="item in typeList", :key="item.code", :name="item.code", :title="item.label")
  component.treeData(v-if="memeberShow", ref="leftcom", :is="typeCom", :key="keyIndex", v-bind="$props", :userList="userList", @updateRight="updateRight")
  .footer
    .user-block
      .user-inline(v-for="u in checkUserList", :key="u.userId", @click="deleteUser(u.userId, checkUserList)")
        img(:src="u.userId | avatar")
</template>

<script>
import { Notify } from "vant";
import { typeCompontent } from "./leftCom";
import Index from "./index.vue";
import { gettouxAvatar } from "@/CommonDP/utils";
export default {
  filters: {
    avatar(id) {
      return gettouxAvatar(id);
    }
  },
  extends: Index,
  computed: {
    checkUserList() {
      return this.showSelectList.find(({ code }) => code === "User")?.array || [];
    }
  },
  methods: {
    // 确定提交
    onSubmit() {
      if (this.overMax) {
        return Notify({ type: "warning", message: "超出人员数量" });
      } else {
        this.resolve(this.allSelectList);
      }
      this.memeberShow = false;
    },
    radioClick(val) {
      this.typeCom = typeCompontent(val);
      this.keyIndex++;
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  padding: 10px 5px;
  display: flex;
  flex-flow: column nowrap;
  .btnRow {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .cancelBtn {
      border: none;
      color: #909399;
    }
    .title {
      font-size: 15px;
    }
    .submitBtn {
      border: none;
      color: #4777E7;
    }
  }

  .treeData {
    width: 100%;
    flex: 1 0 200px;
    overflow-y: auto;
  }
  .footer {
    flex: 0 0;
  }
}

::v-deep .tabs {
  margin: 5px 0;
  width: max-content;

  .van-tabs__nav {
    margin: 0 5px;
  }

  .van-tab {
    padding: 0 15px;
  }
  .van-tab__text {
    width: max-content !important;
  }
}
.user-block {
  display: flex;
  overflow-x: auto;
  flex-flow: row nowrap;
  padding: 4px 0;
  scrollbar-color: initial;
  scrollbar-width: initial;
  &::-webkit-scrollbar {
    width: 0;
    height: 0;
  }
  $block-size: 36px;
  .user-inline {
    flex: 0 0;
    display: flex;
    height: $block-size;
    width: $block-size;
    margin: 0 4px;
    font-size: 10px;
    text-align: center;
    img {
      box-shadow: 0 0 5px -3px #333;
      background-color: #ddd;
      border-radius: $block-size;
      pointer-events: none;
    }
  }
}
</style>
